module.exports = {
    config: require('./config'),
    procedures: {
        facility_access_read: {
            definition: require('./facility_access_read/definition.json'),
            mock_data: require('./facility_access_read/mock_data.json')
        },
        facility_access_gatease_integration: {
            definition: require('./facility_access_gatease_integration/definition.json'),
            mock_data: require('./facility_access_gatease_integration/mock_data.json')
        },
        facility_access_create: {
            definition: require('./facility_access_create/definition.json'),
            mock_data: require('./facility_access_create/mock_data.json')
        },
        facility_list: {
            definition: require('./facility_list/definition.json'),
            mock_data: require('./facility_list/mock_data.json')
        },
        facility_access_list: {
            definition: require('./facility_access_list/definition.json'),
            mock_data: require('./facility_access_list/mock_data.json')
        },
        facility_access_update: {
            definition: require('./facility_access_update/definition.json'),
            mock_data: require('./facility_access_update/mock_data.json')
        },
        crossref_list: {
            definition: require('./crossref_list/definition.json'),
            mock_data: require('./crossref_list/mock_data.json')
        },
        crossref_create: {
            definition: require('./crossref_create/definition.json'),
            mock_data: require('./crossref_create/mock_data.json')
        },
        crossref_update: {
            definition: require('./crossref_update/definition.json'),
            mock_data: require('./crossref_update/mock_data.json')
        },
        crossref_item_create: {
            definition: require('./crossref_item_create/definition.json'),
            mock_data: require('./crossref_item_create/mock_data.json')
        },
        crossref_item_update: {
            definition: require('./crossref_item_update/definition.json'),
            mock_data: require('./crossref_item_update/mock_data.json')
        },
        inventory_count_create: {
            definition: require('./inventory_count_create/definition.json'),
            mock_data: require('./inventory_count_create/mock_data.json')
        },
        inventory_count_item_create: {
            definition: require('./inventory_count_item_create/definition.json'),
            mock_data: require('./inventory_count_item_create/mock_data.json')
        },
        inventory_count_item_list: {
            definition: require('./inventory_count_item_list/definition.json'),
            mock_data: require('./inventory_count_item_list/mock_data.json')
        },
        inventory_count_list: {
            definition: require('./inventory_count_list/definition.json'),
            mock_data: require('./inventory_count_list/mock_data.json')
        },
        inventory_create: {
            definition: require('./inventory_create/definition.json'),
            mock_data: require('./inventory_create/mock_data.json')
        },
        inventory_read: {
            definition: require('./inventory_read/definition.json'),
            mock_data: require('./inventory_read/mock_data.json')
        },
        inventory_list: {
            definition: require('./inventory_list/definition.json'),
            mock_data: require('./inventory_list/mock_data.json')
        },
        inventory_unit_create: {
            definition: require('./inventory_unit_create/definition.json'),
            mock_data: require('./inventory_unit_create/mock_data.json')
        },
        inventory_unit_list: {
            definition: require('./inventory_unit_list/definition.json'),
            mock_data: require('./inventory_unit_list/mock_data.json')
        },
        inventory_unit_read: {
            definition: require('./inventory_unit_read/definition.json'),
            mock_data: require('./inventory_unit_read/mock_data.json')
        },
        inventory_unit_update: {
            definition: require('./inventory_unit_update/definition.json'),
            mock_data: require('./inventory_unit_update/mock_data.json')
        },
        inventory_update: {
            definition: require('./inventory_update/definition.json'),
            mock_data: require('./inventory_update/mock_data.json')
        },
        item_assembly_create: {
            definition: require('./item_assembly_create/definition.json'),
            mock_data: require('./item_assembly_create/mock_data.json')
        },
        item_assembly_list: {
            definition: require('./item_assembly_list/definition.json'),
            mock_data: require('./item_assembly_list/mock_data.json')
        },
        item_create: {
            definition: require('./item_create/definition.json'),
            mock_data: require('./item_create/mock_data.json')
        },
        item_file_create: {
            definition: require('./item_file_create/definition.json'),
            mock_data: require('./item_file_create/mock_data.json')
        },
        item_file_list: {
            definition: require('./item_file_list/definition.json'),
            mock_data: require('./item_file_list/mock_data.json')
        },
        item_group_create: {
            definition: require('./item_group_create/definition.json'),
            mock_data: require('./item_group_create/mock_data.json')
        },
        item_group_item_create: {
            definition: require('./item_group_item_create/definition.json'),
            mock_data: require('./item_group_item_create/mock_data.json')
        },
        item_group_item_list: {
            definition: require('./item_group_item_list/definition.json'),
            mock_data: require('./item_group_item_list/mock_data.json')
        },
        item_group_list: {
            definition: require('./item_group_list/definition.json'),
            mock_data: require('./item_group_list/mock_data.json')
        },
        item_list: {
            definition: require('./item_list/definition.json'),
            mock_data: require('./item_list/mock_data.json')
        },
        item_measure_create: {
            definition: require('./item_measure_create/definition.json'),
            mock_data: require('./item_measure_create/mock_data.json')
        },
        item_measure_list: {
            definition: require('./item_measure_list/definition.json'),
            mock_data: require('./item_measure_list/mock_data.json')
        },
        item_option_create: {
            definition: require('./item_option_create/definition.json'),
            mock_data: require('./item_option_create/mock_data.json')
        },
        item_option_list: {
            definition: require('./item_option_list/definition.json'),
            mock_data: require('./item_option_list/mock_data.json')
        },
        item_read: {
            definition: require('./item_read/definition.json'),
            mock_data: require('./item_read/mock_data.json')
        },
        item_upsert: {
            definition: require('./item_upsert/definition.json'),
            mock_data: require('./item_upsert/mock_data.json')
        },
        item_tag_create: {
            definition: require('./item_tag_create/definition.json'),
            mock_data: require('./item_tag_create/mock_data.json')
        },
        item_tag_list: {
            definition: require('./item_tag_list/definition.json'),
            mock_data: require('./item_tag_list/mock_data.json')
        },
        item_type_list: {
            definition: require('./item_type_list/definition.json'),
            mock_data: require('./item_type_list/mock_data.json')
        },
        item_update: {
            definition: require('./item_update/definition.json'),
            mock_data: require('./item_update/mock_data.json')
        },
        option_type_create: {
            definition: require('./option_type_create/definition.json'),
            mock_data: require('./option_type_create/mock_data.json')
        },
        option_type_list: {
            definition: require('./option_type_list/definition.json'),
            mock_data: require('./option_type_list/mock_data.json')
        },
        option_value_create: {
            definition: require('./option_value_create/definition.json'),
            mock_data: require('./option_value_create/mock_data.json')
        },
        option_value_list: {
            definition: require('./option_value_list/definition.json'),
            mock_data: require('./option_value_list/mock_data.json')
        },
        order_create: {
            definition: require('./order_create/definition.json'),
            mock_data: require('./order_create/mock_data.json')
        },
        order_item_create: {
            definition: require('./order_item_create/definition.json'),
            mock_data: require('./order_item_create/mock_data.json')
        },
        order_item_list: {
            definition: require('./order_item_list/definition.json'),
            mock_data: require('./order_item_list/mock_data.json')
        },
        order_list: {
            definition: require('./order_list/definition.json'),
            mock_data: require('./order_list/mock_data.json')
        },
        order_read: {
            definition: require('./order_read/definition.json'),
            mock_data: require('./order_read/mock_data.json')
        },
        svg_create: {
            definition: require('./svg_create/definition.json'),
            mock_data: require('./svg_create/mock_data.json')
        },
        svg_list: {
            definition: require('./svg_list/definition.json'),
            mock_data: require('./svg_list/mock_data.json')
        },
        svg_read: {
            definition: require('./svg_read/definition.json'),
            mock_data: require('./svg_read/mock_data.json')
        },
        svg_update: {
            definition: require('./svg_update/definition.json'),
            mock_data: require('./svg_update/mock_data.json')
        },
        um_type_list: {
            definition: require('./um_type_list/definition.json'),
            mock_data: require('./um_type_list/mock_data.json')
        },
        um_list: {
            definition: require('./um_list/definition.json'),
            mock_data: require('./um_list/mock_data.json')
        },
        package_type_list: {
            definition: require('./package_type_list/definition.json'),
            mock_data: require('./package_type_list/mock_data.json')
        },
        department_list: {
            definition: require('./department_list/definition.json'),
            mock_data: require('./department_list/mock_data.json')
        },
        department_category_list: {
            definition: require('./department_category_list/definition.json'),
            mock_data: require('./department_category_list/mock_data.json')
        },
        report_facility_snapshot_list: {
            definition: require('./report_facility_snapshot_list/definition.json'),
            mock_data: require('./report_facility_snapshot_list/mock_data.json')
        },
        report_facility_summary_list: {
            definition: require('./report_facility_summary_list/definition.json'),
            mock_data: require('./report_facility_summary_list/mock_data.json')
        }
    }
};
